export type DeriveSharePriceFromPreMoneyProps = {
  issuedShares: number;
  issuedSharesOnStart?: number;
  lockMode?: boolean;
  preMoneyValuation?: number;
};

// Empty or 0 Pre-money must yield 0 — never a stale share price (seeded on mode
// switch or edit hydration), or clearing the field keeps showing the old value.
export const deriveSharePriceFromPreMoney = ({
  issuedShares,
  issuedSharesOnStart,
  lockMode,
  preMoneyValuation,
}: DeriveSharePriceFromPreMoneyProps): number => {
  if (lockMode && preMoneyValuation && issuedSharesOnStart !== undefined)
    return preMoneyValuation / issuedSharesOnStart;

  return preMoneyValuation ? preMoneyValuation / (issuedShares || 1) : 0;
};
